module.exports = __webpack_public_path__ + "img/check_box_black_24dp.19cf1c96.svg";